import React from "react";
import { string, number } from "prop-types";

const RssIcon = ({ color = "#FFF", width = 16, height = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
    <path
      fill={color}
      fillRule="nonzero"
      d="M4.658 13.5c0 .61-.217 1.137-.65 1.582-.434.445-.961.668-1.582.668a2.182 2.182 0 0 1-1.6-.668 2.182 2.182 0 0 1-.668-1.6c0-.62.223-1.148.668-1.582.445-.433.979-.65 1.6-.65.62 0 1.148.217 1.582.65.433.434.65.967.65 1.6zm6.188 1.652a.609.609 0 0 1-.159.422.52.52 0 0 1-.404.176H8.596a.548.548 0 0 1-.405-.158.506.506 0 0 1-.158-.37 7.815 7.815 0 0 0-1.143-3.568 7.88 7.88 0 0 0-2.636-2.636A7.815 7.815 0 0 0 .685 7.875a.506.506 0 0 1-.369-.158.548.548 0 0 1-.158-.405V5.625a.52.52 0 0 1 .176-.404.609.609 0 0 1 .422-.159 10.25 10.25 0 0 1 4.922 1.53c1.5.926 2.712 2.138 3.638 3.638a10.25 10.25 0 0 1 1.53 4.922zm5.062 0a.609.609 0 0 1-.158.422.52.52 0 0 1-.405.176h-1.687a.548.548 0 0 1-.404-.158.506.506 0 0 1-.158-.37c-.094-2.226-.704-4.277-1.829-6.152a13.342 13.342 0 0 0-4.43-4.43C4.964 3.517 2.913 2.907.686 2.813a.506.506 0 0 1-.369-.158.548.548 0 0 1-.158-.404V.562A.52.52 0 0 1 .334.158.609.609 0 0 1 .756 0C3.45.094 5.959.844 8.279 2.25c2.25 1.336 4.055 3.14 5.414 5.414a15.32 15.32 0 0 1 2.215 7.488z"
    />
  </svg>
);

RssIcon.propTypes = {
  color: string,
  width: number,
  height: number
};

export default RssIcon;
